var View = require('views/base/view');

var ActionPlanTopicView = View.extend({
  template: require('./templates/action-plan-topic'),
  className: 'action-plan-topic',
  optionNames: [ 'noWrap' ],
  autoRender: true

});

module.exports = ActionPlanTopicView;
